{
  "save": "Guardar",
  "cancel": "Cancelar",
  "submit": "Enviar",
  "loading": "Cargando...",
  "ok": "OK",
  "add": "Añadir",
  "continue": "Continuar",
  "select": "Seleccionar",
  "selectedCount": "{{count}} seleccionados",
  "notAvailable": "N/D",
  "close": "Cerrar",
  "compressingImage": "Comprimiendo imagen...",
  "hide": "Ocultar",
  "show": "Mostrar",
  "applying": "Aplicando...",
  "back": "Atrás",
  "delete": "Eliminar",
  "duplicate": "Duplicar",
  "lock": "Bloquear",
  "mixed": "Mixto",
  "multipleValues": "Valores múltiples",
  "next": "Siguiente",
  "or": "o",
  "remove": "Eliminar",
  "unlock": "Desbloquear",
  "units": {
    "meters": "Metros",
    "feet": "Pies"
  },
  "sandbox": {
    "title": "Sandbox de {{name}}",
    "badge": "Sandbox",
    "section": "Tu Sandbox",
    "description": "Un espacio privado para aprender y experimentar"
  }
}
